<script lang="ts">
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import TheForkWidget from '$lib/components/theFork/TheForkWidget.svelte';
	import { type ComponentProps } from 'svelte';

	interface FooterProps {
		link?: ComponentProps<typeof Link>;
		theFork?: ComponentProps<typeof TheForkWidget>;
		onAddItineraryClick?: () => void;
		onBookClick?: () => void;
	}

	const { link, theFork, onAddItineraryClick, onBookClick }: FooterProps = $props();
</script>

<div class="button-wrapper p-1 p-bs-3px">
	{#if link}
		<Link
			{...link}
			onclick={(e) => {
				e.stopPropagation();
				onBookClick?.();
			}}
		/>
	{:else if theFork}
		<TheForkWidget
			{...theFork}
			onBookClick={(e) => {
				e.stopPropagation();
				onBookClick?.();
			}}
		/>
	{:else}
		<ButtonAddToItinerary
			color="light"
			size="sm"
			variant="outline"
			class="w-full overflow-hidden"
			onclick={(e) => {
				e.stopPropagation();
				onAddItineraryClick?.();
			}}
		/>
	{/if}
</div>
